import React, { useState, useEffect } from 'react';

const Slider = ({ slides }) => {
  const [current, setCurrent] = useState(0);
  const total = slides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const next = () => setCurrent((prev) => (prev + 1) % total);
  const prev = () => setCurrent((prev) => (prev - 1 + total) % total);

  return (
    <div className="slider-section" style={{
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
      color: 'white',
      padding: '4rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="container">
        <div className="slider-container" style={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '2rem',
          background: 'rgba(255,255,255,0.05)',
          backdropFilter: 'blur(10px)'
        }}>
          <div className="slider-track" style={{
            display: 'flex',
            transition: 'transform 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1)',
            transform: `translateX(-${current * 100}%)`
          }}>
            {slides.map((slide, idx) => (
              <div key={idx} className="slide" style={{
                minWidth: '100%',
                padding: '4rem 2rem',
                textAlign: 'center'
              }}>
                <i className={slide.icon} style={{ fontSize: '3rem', marginBottom: '1rem', color: '#facc15' }}></i>
                <h1 style={{
                  fontSize: '3.5rem',
                  marginBottom: '1rem',
                  background: 'linear-gradient(to right, #facc15, #3b82f6, #8b5cf6)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  color: 'transparent',
                  animation: 'gradientShift 3s ease infinite',
                  backgroundSize: '200% 200%'
                }}>
                  {slide.title}
                </h1>
                <p style={{ fontSize: '1.2rem', maxWidth: '700px', margin: '0 auto', opacity: 0.9 }}>
                  {slide.desc}
                </p>
                <div className="ai-badge" style={{ marginTop: '1.5rem' }}>
                  <i className="fas fa-microchip"></i> AI-powered innovation
                </div>
              </div>
            ))}
          </div>
          
          <button className="slider-btn prev" onClick={prev} style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            left: '1rem',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            fontSize: '2rem',
            padding: '0.5rem 1rem',
            cursor: 'pointer',
            borderRadius: '50%',
            backdropFilter: 'blur(4px)',
            transition: 'all 0.3s ease'
          }}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <button className="slider-btn next" onClick={next} style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            right: '1rem',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            fontSize: '2rem',
            padding: '0.5rem 1rem',
            cursor: 'pointer',
            borderRadius: '50%',
            backdropFilter: 'blur(4px)',
            transition: 'all 0.3s ease'
          }}>
            <i className="fas fa-chevron-right"></i>
          </button>
          
          <div className="dots" style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0.8rem',
            marginTop: '1.5rem'
          }}>
            {slides.map((_, idx) => (
              <div
                key={idx}
                className={`dot ${idx === current ? 'active' : ''}`}
                onClick={() => setCurrent(idx)}
                style={{
                  width: idx === current ? '24px' : '10px',
                  height: '10px',
                  background: idx === current ? '#facc15' : 'rgba(255,255,255,0.4)',
                  borderRadius: idx === current ? '12px' : '50%',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              ></div>
            ))}
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        .slider-btn:hover {
          background: rgba(255,255,255,0.4);
          transform: translateY(-50%) scale(1.1);
        }
        
        .dot:hover {
          transform: scale(1.2);
        }
      `}</style>
    </div>
  );
};

export default Slider;